const mediaItems = [
  {
    title: '《她的私密生活》剧情解析',
    desc: '韩漫热门连载深度剧情拆解，带你发现隐藏细节', views: '12.6万次播放', duration: '15:42',
    img: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20illustration%20with%20warm%20rose%20and%20cream%20tones%2C%20romantic%20manga%20scene%20with%20two%20characters%2C%20play%20button%20overlay%2C%20clean%20modern%20design%2C%20Korean%20webtoon%20aesthetic%2C%20soft%20lighting%2C%20editorial%20quality&width=640&height=360&seq=media-manga-01&orientation=landscape',
  },
  {
    title: '日漫「咒术回战」名场面合集',
    desc: '热血战斗场面逐帧赏析，燃到炸裂的作画', views: '9.8万次播放', duration: '22:10',
    img: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20illustration%20with%20warm%20orange%20and%20dark%20tones%2C%20dynamic%20action%20manga%20fight%20scene%2C%20energy%20explosion%20effects%2C%20play%20button%2C%20Japanese%20anime%20style%2C%20dramatic%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-manga-02&orientation=landscape',
  },
  {
    title: '国漫「一人之下」世界观解读',
    desc: '道家文化与现代都市的奇妙碰撞', views: '8.3万次播放', duration: '18:55',
    img: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20illustration%20with%20warm%20jade%20and%20gold%20tones%2C%20Chinese%20martial%20arts%20manga%20scene%2C%20mystical%20energy%2C%20play%20button%2C%20traditional%20aesthetic%2C%20clean%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-manga-03&orientation=landscape',
  },
  {
    title: '悬疑漫神作《猪圈》深度拆解',
    desc: '反转再反转，结局让你细思极恐', views: '7.1万次播放', duration: '25:30',
    img: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20illustration%20with%20warm%20sepia%20and%20dark%20tones%2C%20mysterious%20thriller%20manga%20atmosphere%2C%20shadowy%20figure%2C%20play%20button%2C%20noir%20vibe%2C%20suspenseful%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-manga-04&orientation=landscape',
  },
  {
    title: '爆笑日常漫画精选配音版',
    desc: '配音演绎搞笑四格漫画，笑到停不下来', views: '11.2万次播放', duration: '12:08',
    img: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20illustration%20with%20warm%20yellow%20and%20cream%20tones%2C%20funny%20chibi%20manga%20characters%2C%20speech%20bubbles%2C%20play%20button%2C%20cheerful%20and%20playful%20design%2C%20editorial%20quality&width=640&height=360&seq=media-manga-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            精彩视频
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            漫画解读与精彩剪辑
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-colors group">
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img src={item.img} alt={`樱花漫画视频 - ${item.title}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-foreground-950/10 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">{item.duration}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.views}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <div key={i + 3} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-accent-200 transition-colors group flex flex-col sm:flex-row">
              <div className="relative aspect-video sm:w-[240px] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
                <img src={item.img} alt={`樱花漫画视频 - ${item.title}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-foreground-950/10 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-lg text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">{item.duration}</span>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.views}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}